import React, {
  useState,
  useContext,
  useEffect,
  Fragment,
  useRef,
} from 'react';
import PropTypes from 'prop-types';
import { BellOutlined, CloseOutlined } from '@ant-design/icons';

import { Link } from 'react-router-dom';
import { VertIcon, VertModal, VertTokens } from '@vertem-core/vertice-ds';
import './VertNotifications.less';
import { LuBell, LuGift } from 'react-icons/lu';

export const getTemplate = (template) => {
  if (template) {
    return 'vert-template-' + template;
  }
  return 'vert-template-default';
};

const VertNotifications = ({ ...props }) => {
  const { className, template, items, isMobile } = props;

  const [isOpen, setIsOpen] = useState(false);

  const { sharedTemplate } = useContext(VertTokens);

  const finalTemplate = template || sharedTemplate;
  const isActive = isOpen ? 'active' : '';

  const notificationRef = useRef(null);

  const closeNotification = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        notificationRef.current &&
        !notificationRef.current.contains(event.target)
      ) {
        closeNotification();
      }
    };
    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('', handleClickOutside);
    };
  }, []);

  const numberOfUnreadItems = items.filter((item) => !item.read).length;
  const showNotificationCounter = numberOfUnreadItems > 0;
  const hasNotification = showNotificationCounter ? 'has-notification' : '';

  const onClickHandler = () => {
    setIsOpen(!isOpen);
  };
  const createNotificationIcon = () => {
    if (props.icon) {
      return props.icon;
    } else {
      return (
        <VertIcon className={`${hasNotification}`} component={BellOutlined} />
      );
    }
  };

  const iconGift = (href) => {
    if (href === '/gifts') {
      return <LuGift className="vert-notification-icon-item" />;
    }
    return <LuBell className="vert-notification-icon-item" />;
  };

  return (
    <div
      ref={notificationRef}
      className={`${getTemplate(
        finalTemplate
      )} vert-notifications ${className}`}
    >
      <div
        className={`vert-notification-icon ${isActive}`}
        onClick={onClickHandler}
      >
        <div className="vert-notification-badge">
          {showNotificationCounter && (
            <span className="notification-badge">{numberOfUnreadItems}</span>
          )}
        </div>
        {createNotificationIcon()}
      </div>
      {isOpen && isMobile && (
        <VertModal
          open={isOpen && isMobile}
          onCancel={onClickHandler}
          spacing="small"
          className="notifications-mobile-modal-spot"
          closeIcon
          centered
        >
          <div className="vert-notifications-wrapper">
            {items.map((item) => {
              return (
                <Fragment key={item.title}>
                  <div className="vert-notifications-content">
                    <p className="vert-notification-date">{item.date}</p>

                    <div className="vert-notification-content-box">
                      {iconGift(item.href)}
                      <p className="vert-notification-title">{item.title}</p>
                    </div>
                    <div className="vert-notification-content-footer">
                      <p className="vert-notification-description">
                        {item.description}
                      </p>
                      {item?.href && (
                        <Link
                          to={item?.href}
                          className="vert-notification-href"
                        >
                          Clique para acessar
                        </Link>
                      )}
                    </div>
                  </div>
                </Fragment>
              );
            })}

            {items.length === 0 && (
              <p className="vert-notification-empty">Não há notificações</p>
            )}
          </div>
        </VertModal>
      )}
      {isOpen && !isMobile && (
        <div className="vert-notifications-wrapper">
          <CloseOutlined
            onClick={onClickHandler}
            className="vert-notification-close-icon"
          />

          {items.map((item) => (
            <div className="vert-notifications-content">
              <p className="vert-notification-date">{item.date}</p>

              <div className="vert-notification-content-box">
                {iconGift(item.href)}

                <p className="vert-notification-title">{item.title}</p>
              </div>

              <div className="vert-notification-content-footer">
                <p className="vert-notification-description">
                  {item.description}
                </p>
                {item.href && item.href !== '' && (
                  <Link
                    to={item.href}
                    className="vert-notification-href"
                    state={{
                      lastRoute: window.location.pathname,
                    }}
                    onClick={() => {
                      setIsOpen(false);
                    }}
                  >
                    {item.hrefText}
                  </Link>
                )}
              </div>
            </div>
          ))}
          {items.length === 0 && (
            <p className="vert-notification-empty">Não há notificações</p>
          )}
        </div>
      )}
    </div>
  );
};

VertNotifications.propTypes = {
  className: PropTypes.string,
  isMobile: PropTypes.bool,
  items: PropTypes.array,
  template: PropTypes.oneOf(['default', 'marketplace']),
  icon: PropTypes.element,
};

export default VertNotifications;
